<template>
  <div class="driver-heatmap-wrap">
    <v-row v-if="heatmapLoading" class="d-flex justify-center">
      <!-- <div style="position: absolute;left:40%;top:30%;z-index: 99;"> -->
      <div>
        <v-btn :loading="true" text x-large fab></v-btn>
        <div class="pl-1">Loading...</div>
      </div>
    </v-row>
    <v-row v-if="!heatmapLoading">
      <v-col cols="7" class="d-flex align-center">
        <div class="mt-5 mr-4 d-flex">
          <span class="pr-1">Select</span>
          <span v-if="activeSort.replace(/_/g, ' ') === 'hrbp'">HRBP</span>
          <span v-else-if="activeSort.replace(/_/g, ' ') === 'hr manager'">HR Manager</span>
          <span v-else>&nbsp;{{activeSort.replace(/_/g, ' ')}}</span>
        </div>
        <v-combobox
          :items="allHeaders"
          multiple
          v-model="selectedHeaders"
          hide-details
        >
          <template v-slot:selection="{ index }">
            <span v-if="index === 0 && selectedHeaders">
              {{selectedHeaders.length}}&nbsp;of&nbsp;{{allHeaders.length}}&nbsp;
              <span v-if="activeSort.replace(/_/g, ' ') === 'hrbp'">HRBP</span>
              <span v-else-if="activeSort.replace(/_/g, ' ') === 'hr manager'">HR Manager</span>
              <span v-else style="text-transform:capitalize">{{activeSort.replace(/_/g, ' ')}}</span>
              &nbsp;selected
            </span>
          </template>
          <template v-slot:prepend-item>
            <v-list-item @click="toggle()">
              <v-list-item-action>
                <v-icon class="ml-n1" :color="selectedHeaders.length > 0 ? 'primary' : ''">{{ icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Select All</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-combobox>
      </v-col>
      <v-col cols="3">
      </v-col>
      <v-col cols="2" class="d-flex justify-end pt-4 mt-4" v-if="selectedHeaders.length > 0">
        <div class="pre-icon cursor-pointer mr-3" @click="displayPre()">
          <i class="las la-chevron-circle-left"></i>
        </div>
        <div v-if="selectedHeaders.length > 0">
          <span v-if="selectedHeaders.length > 0">{{startlimit+1}}</span>
          <span v-else>0</span>
          <span>-</span>
          <span>{{endlimit}}</span>
          <span>&nbsp;of&nbsp;</span>
          <span>&nbsp;{{selectedHeaders.length}}&nbsp;</span>
        </div>
        <div class="next-icon cursor-pointer ml-3" @click="displayNext()">
          <i class="las la-chevron-circle-right"></i>
        </div>
      </v-col>
    </v-row>
    <div class="tableFixHead pb-5"
      v-if="!heatmapLoading
      && tableData[activeDriver]
      && tableData[activeDriver].sub_drivers
      && tableData[activeDriver].sub_drivers[activeSubDriver]
      && tableData[activeDriver].sub_drivers[activeSubDriver].questions"
    >
      <div class="table-wrap">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th class="am-table-head">
                <div class="left-header">
                  <div class="hidden-wrap">&nbsp;</div>
                  <div class="score-wrap">
                    <div>&nbsp;</div>
                    <div class="icon-wrap" style="visibility: hidden;">&nbsp;</div>
                  </div>
                </div>
              </th>
              <th class="overall-score">
                <div class="stat-data">
                  <span>
                    Overall Score
                  </span>
                </div>
              </th>
              <th
                v-for="(header, idx) in activeHeaders"
                :key="idx"
                class=""
              >
                <div class="stat-data">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" v-if="header">{{header.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</span>
                      <span v-bind="attrs" v-on="on" v-else>--</span>
                    </template>
                    <span class="text-capitalize" v-if="header">{{header.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</span>
                    <span v-else>--</span>
                  </v-tooltip>
                </div>
              </th>
            </tr>
          </thead>
          <tbody v-if="tableData[activeDriver]
            && tableData[activeDriver].sub_drivers
            && tableData[activeDriver].sub_drivers[activeSubDriver]
            && tableData[activeDriver].sub_drivers[activeSubDriver].questions
          ">
            <tr
              v-for="(q, key) in tableData[activeDriver].sub_drivers[activeSubDriver].questions"
              :key="`${activeDriver}-${activeSubDriver}-${key}-question`"
              :ref="activeSubDriver"
              :id="key"
              :class="activeDriver === activeDriver ? `activeQuestion ${activeDriver}` : ''"
            >
              <td class="am-table-row" @click="onClickQuestion(key)">
                <div class="left-row">
                    <div class="score-wrap">
                      <div class="icon-wrap">
                        <i class="las la-dot-circle" style="font-size: 16px !important;"></i>
                      </div>
                    <!-- <div class="subdriver-question">{{key}}</div> -->
                    <div class="w-100">
                      <v-row no-gutters>
                        <v-col cols="10" class="subdriver-question">
                          {{key}}
                        </v-col>
                        <v-col cols="2" class="text-right">
                          <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                color="primary"
                                dark
                                v-bind="attrs"
                                v-on="on"
                                @click="onClickQuestion(key)"
                              >las la-external-link-alt</v-icon>
                            </template>
                            <span>View comments</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </div>
              </td>
              <td
                class="subdriver-data"
                :style="`background-color:${getColor(q.average)}`"
              >
                {{q.average}}
              </td>
              <td
                v-for="(header, idx) in activeHeaders"
                :key="idx"
                class="subdriver-data cursor-pointer"
                :style="`background-color:${getColor(getQuestionValue(activeDriver, activeSubDriver, key, header))}`"
                @click="viewQuestionWithScore(key, header)"
              >
                <span v-if="getQuestionValue(activeDriver, activeSubDriver, key, header)">
                  {{getQuestionValue(activeDriver, activeSubDriver, key, header).toFixed(1)}}
                </span>
                <span v-else>--</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- <div
      v-if="!heatmapLoading
      && !tableData[activeDriver]
      && !tableData[activeDriver].sub_drivers"
      class="no-data"
    > -->
    <div
      v-else
      class="no-data"
    >
      <div v-if="!heatmapLoading">Not enough data to generate analysis</div>
    </div>
  </div>
</template>

<script>

import DriversMixin from '../drivers-mixins';

export default {
  name: 'SubDriverHeatmap',

  mixins: [DriversMixin],

  data () {
    return {
      page: 0,
      limit: 7,
      totalData: null,
      endlimit: null,
      startlimit: null,
      lastActiveSubDriver: null,
      lastActiveQuestion: null,
      selectedHeaders: [],
      tableData: {},
      allHeaders: [],
      activeHeaders: []
    };
  },

  props: {
    activeSort: {
      required: true,
      type: String
    },
    activeDriver: {
      required: true,
      type: String
    },
    activeSubDriver: {
      required: true,
      type: String
    }
  },

  watch: {
    driversHeatmap: {
      deep: true,
      immediate: true,
      handler () {
        if (this.driversHeatmap.engagement_heatmap_headers && this.driversHeatmap.engagement_heatmap) {
          this.getTable();
        }
      }
    },
    selectedHeaders: {
      deep: true,
      handler () {
        if (this.selectedHeaders.length === 0) {
          this.activeHeaders = [];
        }
        if (this.selectedHeaders.length === this.allHeaders.length) {
          this.display(this.page);
        }
        if (this.selectedHeaders.length <= this.limit) {
          this.compareCustom(this.page);
        }
      }
    }
  },

  computed: {
    icon () {
      if (this.allOptionSelected) return 'lar la-window-close';
      if (this.someOptionSelected) return 'lar la-minus-square';
      return 'las la-stop';
    },
    allOptionSelected () {
      if (this.allHeaders) {
        return this.selectedHeaders.length === this.allHeaders.length;
      }
      return 0;
    },
    someOptionSelected () {
      return this.selectedHeaders.length > 0 && !this.allOptionSelected;
    }
  },

  methods: {
    onClickQuestion (question) {
      // this.$router.push({
      //   path: '/drivers/questions',
      //   query: { driver: this.activeDriver, subdriver: this.activeSubDriver, question }
      // }).catch(() => {});
      const temp = {
        ...this.updateDriversFilters
      };
      this.$router.push({
        path: '/drivers/view/questions',
        query: {
          driver: this.activeDriver,
          subdriver: this.activeSubDriver,
          question,
          filters: JSON.stringify(temp)
        }
      }).catch(() => {});
    },
    viewQuestionWithScore (question, stage) {
      let t = {};
      // t.segment_filter = this.data.id;
      t[this.activeSort] = [];
      t[this.activeSort].push(stage);
      t = { ...t, ...this.updateReportFilters };
      const temp = {
        filters: t
      };
      this.$router.push({
        path: '/drivers/view/questions',
        query: {
          driver: this.activeDriver,
          subdriver: this.activeSubDriver,
          question,
          filters: JSON.stringify(temp)
        }
      }).catch(() => {});
    },
    getTable () {
      // console.log('this.driversHeatmap', this.driversHeatmap);
      this.allHeaders = this.driversHeatmap.engagement_heatmap_headers;
      this.tableData = this.driversHeatmap.engagement_heatmap;
      this.getTableHeaders();
      this.display(this.page);
    },
    getTableHeaders () {
      if (this.allHeaders && this.allHeaders.length > 0) {
        this.selectedHeaders = this.allHeaders;
        this.totalData = this.allHeaders.length;
      }
    },
    displayPre () {
      if (this.page <= 0) {
        return;
      }
      this.page = this.page - 1;
      this.display(this.page);
    },
    displayNext () {
      if (this.endlimit >= this.totalData) {
        return;
      }
      if (this.selectedHeaders.length < this.limit) {
        return;
      }
      this.page = this.page + 1;
      this.display(this.page);
    },
    display (page) {
      if (page < 0) {
        return;
      }
      const start = this.limit * page;
      const end = this.page * this.limit + this.limit;
      this.startlimit = start;
      this.endlimit = end;
      if (this.allHeaders && this.allHeaders.length > 0) {
        this.selectedHeaders = this.allHeaders;
      }
      if (this.endlimit > this.selectedHeaders.length) {
        this.endlimit = this.selectedHeaders.length;
      }
      const tempData = this.selectedHeaders.slice(this.startlimit, this.endlimit);
      this.activeHeaders = tempData;
    },
    compareCustom (page) {
      if (page < 0) {
        return;
      }
      const start = this.limit * page;
      const end = this.page * this.limit + this.limit;
      this.startlimit = start;
      this.endlimit = end;
      if (this.endlimit > this.selectedHeaders.length) {
        this.endlimit = this.selectedHeaders.length;
      }
      const tempData = this.selectedHeaders.slice(this.startlimit, this.endlimit);
      this.activeHeaders = tempData;
    },
    getQuestionValue (driver, subDriver, question, header) {
      if (this.tableData[driver] && this.tableData[driver].sub_drivers[subDriver] && this.tableData[driver].sub_drivers[subDriver].questions[question]) {
        return this.tableData[driver].sub_drivers[subDriver].questions[question].demographic_wise_avarage[header];
      }
    },
    getColor (val) {
      if (val) {
        let color = '#ffffff';
        const radixPos = String(val).indexOf('.');
        let value = String(val).slice(radixPos).split('.')[1];
        if (!value) {
          value = 0;
        }
        if (val > 0 && val <= 1) {
          color = `rgba(244, 67, 54, 0.${(10 - Number(value)) + 80})`;
        }
        if (val > 1 && val <= 2) {
          color = `rgba(244, 67, 54, 0.${(10 - Number(value)) + 60})`;
        }
        if (val > 2 && val <= 3) {
          color = `rgba(244, 67, 54, 0.${(10 - Number(value)) + 40})`;
        }
        if (val > 3 && val < 4) {
          color = `rgba(246, 251, 252, 0.${Number(value)})`;
        }
        if (val === 4) {
          color = 'rgba(246, 251, 252, 1)';
        }
        if (val > 4 && val < 5) {
          color = `rgba(100, 231, 100, 0.${(Number(value))})`;
        }
        if (val === 5) {
          color = 'rgba(100, 231, 100, 1)';
        }
        return color;
      }
      if (val === 0) {
        return 'rgba(244, 67, 54, 1)';
      }
    },
    toggle () {
      this.$nextTick(() => {
        if (this.allOptionSelected) {
          this.selectedHeaders = [];
          this.activeHeaders = [];
        } else {
          this.display(this.page);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.driver-heatmap-wrap {
  .tableFixHead {
    .table-wrap {
      overflow-y: auto;
    }
    position:relative;
    .analysis-sub {
      font-size: var(--content-sub-size);
      color: var(--color-palceholder);
      padding: 0;
      text-align: left;
    }
    .table-bordered {
      margin: 0 !important;
    }
    table {
      border-collapse: collapse;
    }
    td {
      padding: 8px 16px;
    }
    th {
      padding: 8px;
      border: 1px solid rgba(0,0,0,0.1);
      background: #fff;
      .stat-data {
        text-transform: capitalize;
        max-width: 100px;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-word;
        white-space: nowrap;
        padding: 0;
        text-align: center;
      }
      &.overall-score {
        border: 2px solid rgba(0,0,0,0.2) !important;
        background-color: rgba(0,0,0,0.02);
        .stat-data {
          font-weight: 600;
        }
      }
    }
    tbody {
      tr {
        // border: 1px solid rgba(0,0,0,0.1);
        td {
          text-align: center;
        }
      }
      .driver {
        border: 1px solid rgba(0,0,0,0.1);
      }
    }
    td:first-child, th:first-child {
      // position:sticky;
      // left:0;
      // z-index:1;
      // background-color:transparent;
    }
    .am-table-head {
      // position: sticky;
      z-index: 0;
      justify-content: space-between;
      min-width: 350px;
      background: #ffffff !important;
      width: 100%;
      .left-header {
        display: flex;
        justify-content: space-between;
        width: 100%;
        .score-wrap {
          display: flex;
          th {
            border: 0;
          }
          .icon-wrap {
            pointer-events: none;
          }
        }
      }
    }
    .am-table-row {
      cursor: pointer;
      // display: flex;
      justify-content: space-between;
      min-width: 300px;
      background: #ffffff !important;
      border-bottom: 0;
      padding: 0 !important;
      border: 1px solid rgba(0,0,0,0.1);
      .left-row {
        // display: flex;
        width: 100%;
        padding: 8px 16px !important;
        // padding: 16px !important;
        .left-wrap {
          padding: 8px 16px;
        }
        .score {
          padding: 8px 13px;
          border-left: 1px solid rgba(0, 0, 0, 0.05);
          max-width: 80px;
        }
        .score-wrap {
          display: flex;
          .icon-wrap {
            cursor: pointer;
            padding-top: 4px;
            padding-right: 16px;
          }
        }
        .subdriver-name {
          text-transform: capitalize;
          font-weight: 600;
          text-align: left;
        }
        .subdriver-question {
          font-weight: 500;
          text-align: left;
        }
      }
    }
    .score {
      font-weight: 600;
      border: 2px solid rgba(0,0,0,0.2) !important;
    }
    .question-analysis {
      // display: none;
      .am-table-row {
        background-color: rgba(0,0,0,0.015) !important;
        box-shadow: unset;
        .left-row {
          cursor: pointer;
        }
      }
    }
    .subdriver-analysis {
      .am-table-row {
        background-color: rgba(0,0,0,0.025) !important;
        box-shadow: unset;
        .left-row {
          cursor: pointer;
        }
      }
    }
    .subdriver-data {
      background: #ffffff;
      border: 1px solid rgba(0,0,0,0.05);
      font-weight: 600;
    }
  }
  .no-data {
    width: 100%;
    text-align: center;
    height: 6rem;
    align-items: center;
    display: flex;
    justify-content: center;
    border: none !important;
  }
  .driver-heatmap-range {
    .heat {
      height: 12px;
      text-align: center;
      display: block;
      &.one {
        background-color: rgba(244, 67, 54, 0.4);
      }
      &.two {
        background-color: rgba(244, 67, 54, 0.3);
      }
      &.three {
        background-color: rgba(244, 67, 54, 0.2);
      }
      &.four {
        background-color: rgba(246, 251, 252, 0.4);
      }
      &.five {
        background-color: rgba(246, 251, 252, 0.8);
      }
      &.six {
        background-color: rgba(246, 251, 252, 1);
      }
      &.seven {
        background-color: rgba(100, 231, 100, 0.6);
      }
      &.eight {
        background-color: rgba(100, 231, 100, 0.8);
      }
      &.nine {
        background-color: rgba(100, 231, 100, 1);
      }
    }
  }
  .activeDriver {
    border: 2px solid rgba(0,0,0,0.2);
    border-bottom: 0;
    .am-table-row {
      background-color: rgba(0, 0, 0, 0.1) !important;
    }
  }
  .activeSubDriver {
    border: 2px solid rgba(0,0,0,0.2);
    border-bottom: 0;
    border-top: 0;
    .am-table-row {
      background-color: rgba(0, 0, 0, 0.06) !important;
    }
  }
  .activeQuestion {
    border: 2px solid rgba(0,0,0,0.2);
    border-bottom: 0;
    border-top: 0;
    .am-table-row {
      background-color: rgba(0, 0, 0, 0.02) !important;
    }
  }
}
</style>
